import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from 'components/shared/CustomAlert/CustomAlertContain';
import CustomAutocomplete from 'components/shared/CustomAutocomplete/CustomAutocomplete';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomTextField from 'components/shared/CustomTextField/CustomTextField';
import { useInput } from 'customHook/useInput';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { ClientService } from 'service/client.service';
import { HuddleClientService } from 'service/huddle-client.service';
import { LocationService } from 'service/location.service';
import zeplinColor from 'theme/Color';
import { ClientType } from 'utilities/constants';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
    },
  },
};

const categoryOptions: Record<string, string[]> = {
  'Apparel &amp; Accessories': [
    'Athletic & Footwear',
    'Eyewear',
    'Non-Athletic & Footwear',
    'Other Accessories',
    'Watches & Jewelry',
  ],

  Auto: [
    'Aftermarket (Parts & Equipment)',
    'Aftermarket (Service & Retail)',
    'Car manufactures(Luxury)',
    'Car Manufactures(Non-US)',
    'Dealership',
    'Gas Station',
    'Marketplace',
    'Misc Retail (Bikes, Campers, RV, Boating)',
    'Rental',
    'Tire Manufactures',
  ],
  'B Corp': [],
  'Beverage - Alcohol': [
    'Beer (Craft)',
    'Beer (Import & Domestic)',
    'Hard Cider',
    'Spiked / Hard Seltzer',
    'Spirits (Bourbon, Scotch & Whiskey)',
    'Spirits (Gin)',
    'Spirits (Multiline or Other)',
    'spirits(Rum)',
    'SPirits(Tequila)',
    'Spirits(Vodk)',
    'Wine',
  ],
  'Beverage - Non-Alcoholic': [
    'Beer',
    'Coffee &amp; Tea',
    'Energy Drink',
    'Juice,Ciders &amp; Isotronics',
    'Milk &amp; Protein Drink',
    'Soft Drink &amp; Carbonated',
    'Water &amp; Specialty Water',
  ],
  'Business Services': [
    'Casting & Talent Booking Agency',
    'Commercial Shipping & Logistics',
    'Consulting & other Services',
    'Employment Services',
    'Facility & Event Management',
    'Legal & Law Firms',
    'Marketing PR & Sales Agencies',
    'Media Agency',
    'Office Products (Copiers, Printers, etc…)',
    'Office Services',
    'Other Professional Services',
    'Printing Signage & Install',
    'Public Relation Agency',
    'SPorts Marketing Agency',
  ],
  'Conglomerate &amp; Holding': ['General'],
  'Construction &amp; Industrial': [
    'Construction & Architecture Firms',
    'Electrical',
    'Equipment Rental Sales & repair',
    'HVAC Lighting',
    'Manufacturing Packaging & Shipping',
    'Masonry',
    'Excavation & Landscaping',
    'Materials Tools & Equipment',
    'Other Construction & Industrial',
    'Pest Control',
    'Plumbing',
    'Pool & Jacuzzi',
    'Roofing SIding & Painting',
    'Waste Management',
    'WIndows & Blinds',
  ],
  'Consumer Electronics': [
    'Audio Visual &amp; Wearable',
    'Consumer Electronics (Multiline or Other)',
    'Hardware (Computers, Tablets, etc…)',
  ],
  'Consumer Products': [
    'Appliances &amp; Kitchen',
    'Cosmetics &amp; Skin Care',
    'CPG (Multiline or Other)',
    'Grooming &amp; Toiletry Products',
    'Household Supplies',
    'Pet Supplies',
  ],
  'Consumer Services': [
    'Cleaning (Laundry, carpet, Misc)',
    'Courier &amp; Shipping',
    'Fitness Facilities &amp; Services',
    'Grooming, Salon &amp; Spa',
    'Moving &amp; Storage',
    'on-demand delivery',
    'other consumer services',
    'security systems',
  ],
  Education: [
    'childhood',
    'colleges &amp; universities',
    'educational services &amp; misc',
    'Technical Training &amp; prep courses',
  ],
  Financial: [
    'Affinity &amp; Credit card',
    'Banking',
    'Consumer Financial services',
    'cryptocurrency',
    'Financial Services(Multiline)',
    'Fintech (Financial Technology)',
    'Investment Services',
    'Loan/Mortgage/Payment',
    'Venture Capital &amp; Private Equity',
  ],
  'Food & Bev distribution': [
    'Alcohol Distribution &amp; Wholesale',
    'Bakery',
    'Concessionaire &amp; Catering',
    'convenience store',
    'food distributor',
    'grocery',
    'other food distribution',
    'wine &amp; liquor stores',
  ],
  'Food Products': [
    'Agricultural (Fruits &amp; Vegetables)',
    'Association',
    'Bread Starches &amp; Cereals',
    'Candy Baked Goods &amp; Desserts',
    'Condiments Oils, Spices &amp; sauces',
    'Dairy &amp; cheeses',
    'Food Products(Multiline or other)',
    'Frozen Packaged &amp; Canned',
    'Meatless',
    'Meats Poultry &amp; seafood',
    'Snacks',
    'Vitamins &amp; Supplements',
  ],
  Gaming: ['Betting Services', 'dairy Fantasy Sports', 'Lottery'],
  Government: [
    'Agriculture Fish &amp; Wildlife',
    'Armed Forces',
    'Commerce &amp; Economic',
    'Health',
    'Other Government Initiatives',
    'Tourism',
    'Transportation &amp; Public Safety',
  ],
  Healthcare: [
    'Ambulance &amp; Urgent Care',
    'Cannabis (CBD, Hemp)',
    'Clinic Labs &amp; Specialty Services',
    'Dental Care',
    'Equipment Supplies &amp; Distribution',
    'Healthcare - General',
    'Hospital',
    'Oncology',
    'Ortho Physical &amp; Sports Med',
    'Pharma &amp; Over the Counter',
    'rehabilitation',
    'Vision',
  ],
  'Home Furnishings': [
    'Flooring',
    'furniture',
    'Houseware &amp; Specialty',
    'Mattress &amp; Bedding',
  ],
  'Hotel, Restaurant, Leisure': [
    'Bars, Breweries &amp; Wineries',
    'Casinos, Race tracks &amp; Gaming',
    'Cruise Lines &amp; Travel Tours',
    'Hotel Resort',
    'Restaurants &amp; Event Spaces',
  ],
  Insurance: [
    'Insurance Broker',
    'Life &amp; Health',
    'Other Insurance',
    'Property &amp; casualty',
  ],
  'Leisure &amp; Recreation': [
    'Arts, Crafts, Toys, Games, Collectibles',
    'Athletics Equipment',
    'Concerts, Festivals, Shows &amp; Theaters',
    'General &amp; Other Attractions',
    'Golf Courses &amp; Country Clubs',
    'Museums, Zoos &amp; ENtertainment',
    'Music &amp; Entertainment Equipment',
    'Teams, Venues, Events &amp; Leagues',
    'Theme Park',
  ],
  Manufacturing: ['Miscellaneous Manufacturing', 'Transportation Manufacturing'],
  Materials: [
    'Chemicals, Metals &amp; mining',
    'Container &amp; packaging',
    'Paper &amp; forest Products',
  ],
  Media: [
    'Digital &amp; Social',
    'Media (Multiline or other)',
    'Motion Pictures &amp; Studios',
    'Publishing',
    'Radio',
    'TV/ Streaming Networks &amp; Studios',
  ],
  'Nonprofits, Charities, Association': [
    'Health Causes Charities &amp; Associations',
    'Hunger Causes Charities &amp; Association',
    'Other Charities &amp; non-profits',
    'Other Organisations',
    'Religious Causes, Groups &amp; Association',
    'Unions &amp; Associations',
  ],
  Photographer: [],
  Prospect: [],
  Public: [],
  'Quick Serve Restaurants': [
    'Burger',
    'chicken',
    'Coffee &amp; Tea',
    'Dessert',
    'Mexican/Latin American',
    'Other QSR',
    'Pizza',
    'Sandwich',
  ],
  'Real Estate': ['Properties &amp; developments', 'Real Estate Agencies, Services &amp; other'],
  Retail: [
    'Apparel, Footwear &amp; Accessories',
    'Appliances',
    'Athletic Apparel &amp; Sporting Goods',
    'Consumer Electronics',
    'Dispensary',
    'Florist',
    'Home Improvement',
    'Jewelry',
    'Mass Merchant &amp; Department Stores',
    'Office Services',
  ],
  Technology: [
    'Cloud Data &amp; CRM solutions',
    'Digital Audio',
    'ecommerce',
    'Hardware',
    'IT &amp; Network services',
    'Multiline',
    'NFT',
    'other Technology',
    'Saas',
    'Security',
    'software',
    'web/app (other)',
    'web/app(sports &amp; games)',
    'web/app(visual, social &amp; collaboration)',
  ],
  Telecommunications: ['Equipment &amp; Services', 'Integrated (TV/ Internet/ Phone)', 'wireless'],
  Transportation: [
    'Airline',
    'Infrastructure (Aiports , ports, facilities)',
    'Marine',
    'road &amp; rail',
    'services(Agents &amp; other)',
  ],
  Utilities: [
    'electric',
    'natural gas &amp; oil',
    'renewable',
    'services &amp; energy industries (multiline or other)',
    'water &amp; other',
  ],
};

const BusinessForm = ({
  handleSelection,
  setSelectedItems,
  selectedItems,
  data,
  getAllClient,
  onClose,
}: {
  handleSelection: (item: any, type: string | boolean) => void;
  setSelectedItems: React.Dispatch<
    React.SetStateAction<{
      salutation: string[];
      agency: any[];
      league: string[];
      team: string[];
      position: string[];
      number: string[];
      status: string[];
      college: string[];
      time: string[];
      client: boolean[];
      type: string[];
      industry: string[];
      category: string[];
      captiv8: any[];
    }>
  >;
  selectedItems: {
    salutation: string[];
    agency: any[];
    league: string[];
    team: string[];
    position: string[];
    number: string[];
    status: string[];
    college: string[];
    time: string[];
    client: boolean[];
    type: string[];
    industry: string[];
    category: string[];
    captiv8: any[];
  };
  data?: any;
  getAllClient: () => Promise<void>;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xl'));
  const wait = useRef<any>();
  const [error, setError] = useState(false);

  const [formLoading, setFormLoading] = useState(false);
  const [date] = useState<Dayjs | null>(data?.birthdate ? dayjs(data?.birthdate) : null);

  const [loading, setLoading] = useState(false);
  const [dropdowns, setDropdowns] = useState<any>({});
  const [client] = useState(data ? data?.isPersonAccount : true);
  const [agencyData, setAgencyData] = useState<any[]>([]);
  const [billingSuggestion, setBillingSuggestion] = useState({ Name: '', ID: '' });
  const [address, setAddress] = useState<any[]>([]);
  const suggestionAPI = async (value: string) => {
    try {
      setLoading(true);
      const res = await LocationService.getAddressSuggestion(value?.toLocaleLowerCase());
      setAddress(res.map((val: any) => ({ ID: val?.description, Name: val?.description })));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddressSearch = async (e: React.SyntheticEvent, value: string) => {
    clearTimeout(wait.current);
    const getSuggestion = setTimeout(() => suggestionAPI(value), 1000);
    wait.current = getSuggestion;
  };
  const {
    handleChange: handleAccountNameChange,
    handleBlur: handleAccountNameBlur,
    value: accountName,
    invalid: invalidAccountName,
    didChange: didAccountNameChange,
  } = useInput(data ? data?.accountName : '', () => true);

  const {
    handleChange: handleFaxChange,
    handleBlur: handleFaxBlur,
    value: fax,
    invalid: invalidFax,
    didChange: didFaxChange,
  } = useInput(data ? data?.fax : '', () => true);
  const {
    handleChange: handlePhoneChange,
    handleBlur: handlePhoneBlur,
    value: phone,
    invalid: invalidPhone,
    didChange: didPhoneChange,
  } = useInput(data ? data?.phone : '', () => true);
  const {
    handleChange: handleWebsiteChange,
    handleBlur: handleWebsiteBlur,
    value: website,
    invalid: invalidWebsite,
    didChange: didWebsiteChange,
  } = useInput(data ? data?.website : '', () => true);

  const {
    handleChange: handleBillingStreetChange,
    handleBlur: handleBillingStreetBlur,
    value: billingStreet,
    setValue: setBillingStreet,
    invalid: invalidBillingStreet,
    didChange: didBillingStreetChange,
  } = useInput(data?.billingAddress?.street ? data?.billingAddress?.street : '', () => true);

  const {
    handleChange: handleBillingCityChange,
    handleBlur: handleBillingCityBlur,
    setValue: setBillingCity,
    value: billingCity,
    invalid: invalidBillingCity,
    didChange: didBillingCityChange,
  } = useInput(data?.billingAddress?.city ? data?.billingAddress?.city : '', () => true);

  const {
    handleChange: handleBillingStateChange,
    handleBlur: handleBillingStateBlur,
    setValue: setBillingState,
    value: billingState,
    invalid: invalidBillingState,
    didChange: didBillingStateChange,
  } = useInput(data?.billingAddress?.state ? data?.billingAddress?.state : '', () => true);
  const {
    handleChange: handleBillingZipChange,
    handleBlur: handleBillingZipBlur,
    setValue: setBillingZip,
    value: billingZip,
    invalid: invalidBillingZip,
    didChange: didBillingZipChange,
  } = useInput(
    data?.billingAddress?.postalCode ? data?.billingAddress?.postalCode : '',
    () => true,
  );
  const {
    handleChange: handleBillingCountryChange,
    handleBlur: handleBillingCountryBlur,
    setValue: setBillingCountry,
    value: billingCountry,
    invalid: invalidBillingCountry,
    didChange: didBillingCountryChange,
  } = useInput(data?.billingAddress?.country ? data?.billingAddress?.country : '', () => true);
  const {
    handleChange: handleBioChange,
    handleBlur: handleBioBlur,
    value: bio,
    invalid: invalidBio,
    didChange: didBioChange,
  } = useInput(data ? data?.bio : '', () => true);

  const handleDeleteItems = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    setSelectedItems({
      ...selectedItems,
      [key]: [...selectedItems.agency?.filter((val: any) => val !== item)],
    });
  };
  const getDropdownValue = async (type: string) => {
    try {
      const res = await ClientService.getClientDropdowns(type);
      setDropdowns(res);
      setAgencyData(res?.agency);
    } catch (err) {
      console.error(err);
    }
  };
  const addClient = async () => {
    try {
      setFormLoading(true);
      const props = {
        Name: `${accountName}`,
        ...(date && { PersonBirthdate: date }),
        ...(selectedItems?.captiv8[0] && { Captive8_Creator_Id__c: selectedItems?.captiv8[0]?.Id }),
        ...(selectedItems?.agency[0] && {
          ParentId: selectedItems?.agency[0]?.Id,
        }),
        RecordTypeName: ClientType.Business,
        Client__c: client,
        BillingAddress: {
          city: billingCity,
          country: billingCountry,
          state: billingState,
          street: billingStreet,
          postalCode: billingZip,
        },
        GD_Bio__c: bio,
        Fax: fax,
        ...(selectedItems?.type[0] &&
          selectedItems?.type[0] !== 'None' && { Type: selectedItems.type[0] || '' }),
        Industry: selectedItems.industry[0] || '',
        ...(selectedItems?.category[0] &&
          selectedItems?.category[0] !== 'None' && {
            Category__c: selectedItems.category[0] || '',
          }),
        Phone: phone,
        Website: website,
      };

      let res;
      res = data?.accountId
        ? await HuddleClientService?.editHuddleClient(props, data?.accountId)
        : await HuddleClientService.addHuddleClient(props);
      client && sessionStorage.setItem('platform', 'huddle');

      client && sessionStorage.setItem('new-client', res?.recordId || res?.clientId);
      data?.accountId && getAllClient();
      onClose(false);
    } catch (err) {
      setError(true);
    } finally {
      setFormLoading(false);
    }
  };
  const disable =
    !accountName ||
    !selectedItems?.type?.filter((val) => val !== 'None')?.length ||
    !selectedItems?.industry?.filter((val) => val !== 'None')?.length;
  useEffect(() => {
    getDropdownValue(ClientType.Business);
  }, []);
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Business Information
          </Typography>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleAccountNameBlur}
              onChange={handleAccountNameChange}
              name='Account Name'
              text={accountName}
              form={true}
              error={
                invalidAccountName && didAccountNameChange ? 'Please enter valid Account Name' : ''
              }
              label={'Account Name'}
              type='text'
              tabindex={1}
              required
            />
          </Box>

          <CustomAutocomplete
            popupIcon='/assets/Search.svg'
            required={false}
            options={agencyData || []}
            getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
            label={'Parent account'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              handleSelection(value, 'agency');
            }}
            value={selectedItems?.agency[0]}
            handleFilter={() => {}}
            placeholder='Parent account'
            currentLength={agencyData?.length}
            totalLength={agencyData?.length}
            next={() => {}}
            multiple={false}
          />
          <FormControl sx={{ width: '100%' }}>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              required
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
                '& .MuiFormLabel-asterisk': {
                  color: zeplinColor.Error,
                },
              }}
            >
              Type
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              size={isXs ? 'small' : 'medium'}
              required
              value={
                typeof selectedItems.type == 'string' ? selectedItems.type : selectedItems.type[0]
              }
              onChange={(e) => {
                handleSelection(e, 'type');
                setSelectedItems((prev) => ({ ...prev, category: [] }));
              }}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Type'
                />
              }
              renderValue={(selected) => {
                return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
              }}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {[...(dropdowns?.Type ?? []), 'None'].map((name) => (
                <MenuItem key={name} value={name}>
                  <Radio
                    checked={selectedItems.type.indexOf(name) > -1}
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />

                  {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                required
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                  '& .MuiFormLabel-asterisk': {
                    color: zeplinColor.Error,
                  },
                }}
              >
                Industry
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                required
                value={
                  typeof selectedItems.industry == 'string'
                    ? selectedItems.industry
                    : selectedItems.industry[0]
                }
                onChange={(e) => handleSelection(e, 'industry')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Industry'
                  />
                }
                renderValue={(selected) => {
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.Industry ?? []), 'None'].map((name) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.industry.indexOf(name) > -1}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />

                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ width: '100%' }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Category
              </InputLabel>
              <Select
                disabled={
                  !selectedItems?.type[0] ||
                  selectedItems?.type[0] === 'None' ||
                  ['B Corp', 'Photographer', 'Prospect', 'Public']?.includes(selectedItems?.type[0])
                }
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                value={
                  typeof selectedItems.category == 'string'
                    ? selectedItems.category
                    : selectedItems.category[0]
                }
                onChange={(e) => handleSelection(e, 'category')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='category'
                  />
                }
                renderValue={(selected) => {
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.Category__c ?? []), 'None'].map(
                  (name) =>
                    (categoryOptions[selectedItems?.type[0]]
                      ?.map((val) => val?.toLocaleLowerCase())
                      ?.includes(name?.toLocaleLowerCase()) ||
                      categoryOptions[selectedItems?.type[0]]?.length === 0) && (
                      <MenuItem key={name} value={name}>
                        <Radio
                          checked={selectedItems.category.indexOf(name) > -1}
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />

                        {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                      </MenuItem>
                    ),
                )}
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Contact Information
          </Typography>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handlePhoneBlur}
              onChange={handlePhoneChange}
              name='Phone'
              text={phone}
              form={true}
              error={invalidPhone && didPhoneChange ? 'Please enter valid Phone' : ''}
              label={'Phone'}
              isPhoneMask
              tabindex={1}
            />
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handleFaxBlur}
              onChange={handleFaxChange}
              name='Fax'
              text={fax}
              form={true}
              error={invalidFax && didFaxChange ? 'Please enter valid Fax' : ''}
              label={'Fax'}
              type='number'
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handleWebsiteBlur}
              onChange={handleWebsiteChange}
              name='Website'
              text={website}
              form={true}
              error={invalidWebsite && didWebsiteChange ? 'Please enter valid Website' : ''}
              label={'Website'}
              type='text'
              tabindex={1}
            />
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Billing Address
          </Typography>
          <CustomAutocomplete
            loading={loading}
            popupIcon='/assets/Search.svg'
            required={false}
            options={address || []}
            getOptionLabel={(option: any) => option?.Name}
            label={'Search address'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              setBillingSuggestion(value);
              setBillingStreet(value?.Name.split(',')[0]);

              setBillingCity(value?.Name.split(',')[value?.Name.split(',')?.length - 3]);
              setBillingState(value?.Name.split(',')[value?.Name.split(',')?.length - 2]);
              setBillingCountry(value?.Name.split(',')[value?.Name.split(',')?.length - 1]);
            }}
            value={billingSuggestion}
            handleFilter={handleAddressSearch}
            placeholder='Search address'
            currentLength={address?.length || 0}
            totalLength={address?.length || 0}
            next={() => {}}
            multiple={false}
          />
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingStreetBlur}
              onChange={handleBillingStreetChange}
              name='Street'
              text={billingStreet}
              form={true}
              error={
                invalidBillingStreet && didBillingStreetChange ? 'Please enter valid Street' : ''
              }
              label={'Street'}
              type='text'
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingCityBlur}
              onChange={handleBillingCityChange}
              name='City'
              text={billingCity}
              form={true}
              error={invalidBillingCity && didBillingCityChange ? 'Please enter valid City' : ''}
              label={'City'}
              type='text'
              tabindex={1}
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingStateBlur}
              onChange={handleBillingStateChange}
              name='State/Province'
              text={billingState}
              form={true}
              error={invalidBillingState && didBillingStateChange ? 'Please enter valid State' : ''}
              label={'State/Province'}
              type='text'
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingZipBlur}
              onChange={handleBillingZipChange}
              name='Zip/Postal code'
              text={billingZip}
              form={true}
              error={invalidBillingZip && didBillingZipChange ? 'Please enter valid Zip' : ''}
              label={'Zip/Postal code'}
              type='number'
              tabindex={1}
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingCountryBlur}
              onChange={handleBillingCountryChange}
              name='Country'
              text={billingCountry}
              form={true}
              error={
                invalidBillingCountry && didBillingCountryChange ? 'Please enter valid Country' : ''
              }
              label={'Country'}
              type='text'
              tabindex={1}
            />
          </Box>
          <CustomTextField
            style={{ width: '100%' }}
            onBlur={handleBioBlur}
            onChange={handleBioChange}
            name='Bio'
            text={bio}
            form={true}
            error={false}
            label={'Bio'}
            multiline
            type='text'
            tabindex={1}
          />
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          position: 'sticky',
          bottom: '0px',
          margin: 'auto',
          zIndex: '100',
          padding: '24px 0px',
          backgroundColor: zeplinColor.Neutral1,
        }}
      >
        <CustomButton
          disabled={disable || formLoading}
          onClick={() => {
            addClient();
          }}
          variant='contained'
          color={disable ? 'customDisable' : 'primary'}
          style={{
            borderRadius: '14px',
            height: 56,
            width: '100%',
            '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
          }}
          textStyle={{ color: disable ? zeplinColor.Neutral8 : zeplinColor.Neutral1 }}
          text={
            formLoading
              ? data?.accountId
                ? 'Saving'
                : 'Creating Client...'
              : data?.accountId
                ? 'Save'
                : 'Create Client'
          }
        />
      </Box>
      <CustomAlert
        open={error}
        handleClose={() => {
          setError(false);
        }}
        message={
          <CustomAlertContain
            alertIcon={<img src='/assets/error.svg' width={24} height={24} />}
            alert={'Something went wrong.'}
            error
          />
        }
        error
      />
    </>
  );
};

export default BusinessForm;
